const getAdobeAppConfig = () => {
    const params = new URLSearchParams(
        decodeURIComponent(document.location.search)
    );
    const rsid = params.get('rsid') || null;
    const adobe_mc = params.get('adobe_mc') || null;
    return { rsid, adobeMc: adobe_mc };
};

export default getAdobeAppConfig;
